import axios from "axios";
import { CUSTOMER_API_URL } from "../constants";
import { Setting } from "../App";

export const useSubscriptionPause = (token: string, contractId: string) => {
  const subscriptionPause = (
    success: () => void,
    failed?: (message: string) => void
  ) => {
    (async () => {
      try {
        const param = {
          subscriptionId: contractId,
          status: "paused",
        }

        await axios.post(
          `${CUSTOMER_API_URL}?action=updateSubscription`,
          param,
          {
            headers: { Authorization: token },
          }
        );
        success();
      } catch (e) {
        if (failed) {
          failed(e.message);
        }
      }
    })();
  };

  const subscriptionPauseCancel = (
    success: () => void,
    failed?: (message: string) => void
  ) => {
    (async () => {
      try {
        const param = {
          subscriptionId: contractId,
          status: "active",
        }

        await axios.post(
          `${CUSTOMER_API_URL}?action=updateSubscription`,
          param,
          {
            headers: { Authorization: token },
          }
        );
        success();
      } catch (e) {
        if (failed) {
          failed(e.message);
        }
      }
    })();
  };

  return {
    subscriptionPause,
    subscriptionPauseCancel
  };
};
